import React, { Component, Fragment } from 'react'
import _ from 'lodash'
import {
  Button,
  Icon,
  Popconfirm,
  Tooltip,
  Modal,
  Checkbox,
  message,
  Alert,
  Form,
  Input,
  InputNumber,
  Spin,
  List,
  Row,
  Dropdown,
  Menu,
  Divider,
  Upload,
  Select
} from 'antd'
import axios from 'axios'
import { QuizCreation, QuizQuestions } from './internal'

import { Quiz } from './styled'
import { withTranslation } from 'react-i18next'
import { api } from '../../../../services'
import classNames from 'classnames'
import { PopupMedia } from '../../../../views/Library/internal'
import Dropzone from 'react-dropzone'
import nanoid from 'nanoid'
import { CloseOutlined } from '@ant-design/icons'
import { FaDesktop, FaDownload, FaExclamationTriangle } from 'react-icons/fa'
import { config } from '../../../../constants'
import { getToken, fetchRefreshToken } from '../../../../services/api/user'

const { Option } = Select

const { confirm } = Modal
class EQuiz extends Component {
  state = {
    isFetching: false,
    refreshToken: null,
    shlToken: null,
    formCreateVisible: false,
    manageVisible: false,
    questionsVisible: false,
    editQuestion: null,
    currentQuiz: null,
    enableQuizGame: false,
    showMediaLibrary: false,
    selectedImage: '',
    processingScreenCapture: false,
    coverLink: null,
    simulationMode: 'From Web',
    isAddSimulation: false,
    savingSimulation: false,
    isUploadingSimulation: false,
    selectedSimulation: [],
    selectedOption: 'Default',
    sectionId: 0,
    simulationTitle: '',
    simulationScore: 5,
    showSimulationModal: false,
    simulationList: [],
    simulationListLoading: false,
    totalSimulations: 0 // Add this for pagination
  }

  async componentDidMount() {
    const {
      pageBuilder: { contentId, isSimulation }
    } = this.props
    this.setState({
      ...(isSimulation && { isAddSimulation: true }),
      formCreateVisible: true
    })

    try {
      const token = await getToken()
      const refreshToken = await fetchRefreshToken()
      this.setState({ shlToken: token, refreshToken: refreshToken })
    } catch (err) {
      console.error('Error fetching SHL token:', err)
    }

    if (contentId) {
      this.setState({ isFetching: true })
      api.quizes.getQuizByIdAnswers(contentId).then(res => {
        if (res.data) {
          console.log("res.data currentQuiz", res.data)

          // Determine simulationMode safely
          let simulationMode = ""
          if (res.data.simulation && res.data.simulation.mode) {
            if (res.data.simulation.mode === "from_elearning_app") {
              simulationMode = "Create with Screen Capture"
            } else if (res.data.simulation.mode === "from_web") {
              simulationMode = "From Web"
            } else if (res.data.simulation.mode === "from_org_library") {
              simulationMode = "Add from Organization library"
            }
          }

          this.setState({
            currentQuiz: res.data,
            enableQuizGame: res.data.is_quizgame,

            ...(res.data.is_quizgame && {
              selectedImage: res.data.cover,
              coverLink: res.data.cover.link
            }),

            ...(this.state.isAddSimulation &&
              res.data.simulation?.mode !== "from_org_library" &&
              res.data.simulation?.links && {
              selectedSimulation: res.data.simulation.links
            }),

            isFetching: false,
            simulationMode
          })
          if (simulationMode === 'Add from Organization library') {
            this.showSimulationListModal()
          }
        }
      })
    }
  }

  setVisible = (name, value) => {
    this.setState({
      [name]: value
    })
  }

  onAddQuestion = () => {
    this.setState({
      questionsVisible: true,
      editQuestion: null
    })
  }

  onEditQuestion = id => {
    this.setState({
      questionsVisible: true,
      editQuestion: {
        id,
        ...this.state.currentQuiz.questions[id]
      }
    })
  }

  // 1. Update the simulationMode change handler
  handleSimulationModeChange = (value) => {
    this.setState({ simulationMode: value })

    // Automatically open modal when "Add from Organization library" is selected
    if (value === 'Add from Organization library') {
      this.showSimulationListModal()
    }
  }

  // 2. Add the save handler
  handleSaveSimulationDesktop = async () => {
    const { selectedSimulation, simulationTitle, simulationScore, sectionId, selectedOption } = this.state

    console.log({
      selectedSimulation,
      simulationTitle,
      simulationScore,
      sectionId,
      selectedOption
    });

    // if (!selectedSimulation || selectedSimulation.length === 0) {
    //   message.warning('Please select at least one simulation')
    //   return
    // }

    // try {
    //   this.setState({ savingSimulation: true })

    //   // Your save logic here
    //   const response = await axios.post('/api/simulations/save', {
    //     title: simulationTitle,
    //     score: simulationScore,
    //     sectionId: selectedOption !== 'Default' ? sectionId : null,
    //     simulations: selectedSimulation.map(sim => sim.id),
    //     mode: 'organization_library'
    //   })

    //   message.success('Simulation saved successfully!')
    //   console.log('Saved simulation:', response.data)

    //   // Reset form or redirect as needed
    //   this.setState({
    //     selectedSimulation: [],
    //     simulationTitle: '',
    //     simulationScore: 5
    //   })

    // } catch (error) {
    //   message.error('Failed to save simulation')
    //   console.error('Error saving simulation:', error)
    // } finally {
    //   this.setState({ savingSimulation: false })
    // }
  }

  // Add this method to fetch simulations from API
  showSimulationListModal = async () => {
    this.setState({
      showSimulationModal: true,
      simulationListLoading: true
    })

    try {
      const { shlToken } = this.state

      const response = await fetch(`${config.baseURL}quizes`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${shlToken}`,
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }

      const data = await response.json()

      const simulations = data
        .filter(item => item.is_simulation)
        .map(item => ({
          id: item.id,
          name: item.title,
          description: item.quiz_data?.description || 'No description',
          date: new Date(item.created_at).toLocaleDateString(),
          icon: 'file-text',
          fullData: item
        }))

      this.setState({
        simulationList: simulations,
        simulationListLoading: false,
        totalSimulations: simulations.length
      })
    } catch (error) {
      message.error('Failed to load simulations')
      console.error('Error fetching simulations:', error)
      this.setState({
        simulationListLoading: false,
        simulationList: []
      })
    }
  }

  handleSimulationSelect = (simulation) => {
    message.success(`Selected: ${simulation.name}`)
    console.log('Selected simulation:', simulation)

    // Check if already selected
    const isAlreadySelected = this.state.selectedSimulation.some(
      item => item.id === simulation.id
    )

    if (isAlreadySelected) {
      message.warning('This simulation is already selected')
      return
    }

    this.setState({
      showSimulationModal: false,
      selectedSimulation: [...this.state.selectedSimulation, simulation]
    })
  }

  handleModalClose = () => {
    this.setState({ showSimulationModal: false })
  }

  onRemoveQuestion = index => {
    const { quizesActions } = this.props

    const questions = this.state.currentQuiz.questions
    const id = this.state.currentQuiz.id

    questions.splice(index, 1)

    quizesActions.updateQuestions(
      {
        questions
      },
      id
    )
  }

  handleInput = ({ id, questions_count: count }) => {
    const { uid, handleParams } = this.props

    if (handleParams) {
      handleParams(uid, { contentId: id, questions_count: count })
    }
  }

  setCurrentQuiz = data => {
    this.setState({
      currentQuiz: data
    })
  }

  updateCurrentQuizQuestions = data => {
    this.setState(
      {
        enableQuizGame: false,
        currentQuiz: {
          ...this.state.currentQuiz,
          questions: data
        }
      },
      () => {
        if (this.state.currentQuiz.is_quizgame) {
          const canAddGame =
            data &&
            data.every(
              item => item.type === 'single' || item.type === 'multiple'
            )
          // if quiz with game has new set of questions that has any item with answer type that is not single or multiple, update api
          if (!canAddGame) {
            this.updateQuiz({
              is_quizgame: false,
              cover_id: null,
              cover: {}
            })
          }
        }
      }
    )
  }

  toggleQuizInGames = () => {
    const questions = this.state.currentQuiz.questions
    if (
      questions &&
      !questions.every(
        item => item.type === 'single' || item.type === 'multiple'
      )
    ) {
      message.error(
        `You can add games only if all the questions have answer type of either single or multiple.`
      )
      this.setState({ enableQuizGame: false })
      return
    }
    this.setState(
      {
        enableQuizGame: !this.state.enableQuizGame
      },
      () => {
        if (this.state.currentQuiz.is_quizgame && !this.state.enableQuizGame) {
          this.updateQuiz({
            is_quizgame: false,
            cover_id: null,
            cover: {}
          })
        }
      }
    )
  }

  handleSelectImage = games => {
    const item = _.head(
      games.rows && games.rows.filter(value => value.isSelected)
    )
    this.setState(
      {
        selectedImage: item,
        showMediaLibrary: false,
        coverLink: item.link
      },
      () => {
        this.updateQuiz({
          is_quizgame: true,
          cover_id: item.id
        })
      }
    )
  }

  updateQuiz = async (params) => {
    const { id } = this.state.currentQuiz
    const data = { ...this.state.currentQuiz, ...params }


    console.log("data sending to quiz update", data)

    const quizRes = await api.quizes.quizUpdate(data, id)

    console.log("quizRes after update", quizRes)

    if (quizRes?.data?.is_simulation) {
      this.setState({ savingSimulation: false })
    }

    await api.quizes.getQuizByIdAnswers(id)

    this.handleInput(data)
    this.setCurrentQuiz(data)

    return true
  }


  toggleSimulationModal = () => {
    this.setState({
      isAddSimulation: !this.state.isAddSimulation
    })
  }

  onDropSimulation = (...dropped) => {
    const files = dropped[1]

    const { libraryActions } = this.props

    this.setState(
      {
        isUploadingSimulation: true
      },
      () => {
        files.forEach((file, index) => {
          libraryActions
            .upload(file, { isSimulation: true, category: 'game' })
            .then(response => {
              const newArr = [...this.state.selectedSimulation, response]
              this.setState({
                selectedSimulation: newArr,
                ...(index + 1 === files.length && {
                  isUploadingSimulation: false
                })
              })
            })
        })
      }
    )
  }

  deleteSimulationFile = id => {
    const { t } = this.props
    let that = this
    confirm({
      title: t('v3:are_sure_simulation'),
      content: '',
      okText: t('v4:yes'),
      okType: 'danger',
      cancelText: t('v4:no'),
      onOk() {
        that.confimDeleteSimulationFile(id)
      },
      onCancel() {
        console.log('Cancel')
      }
    })
  }

  confimDeleteSimulationFile = simId => {
    this.setState(state => ({
      simulationMode: 'From Web',
      selectedSimulation: state.selectedSimulation.filter(
        ({ id }) => id !== simId
      )
    }))
  }

  // Modify handleSaveSimulationDeskstop to return a Promise
  handleSaveSimulationDeskstop = () => {
    return new Promise((resolve, reject) => {
      const {
        form: { validateFields },
        handleCloseQuizModal,
        handleAddNewQuizElement,
        lessonId,
        courseId,
        t
      } = this.props

      const { currentQuiz, sectionId, selectedOption, simulationMode } = this.state

      console.log("currentQuiz:", currentQuiz);
      console.log("sectionId:", sectionId);
      console.log("simulationMode:", simulationMode);

      validateFields((err, values) => {
        console.log(err, values)
        if (!err) {
          if (selectedOption !== 'Default' && sectionId === 0) {
            console.log(
              'selectedOption',
              selectedOption,
              'sectionId',
              sectionId
            )
            message.error(`${t('v4:select_upload_section_id')}`)
            reject(new Error('Section ID required'))
            return
          }

          this.setState({ savingSimulation: true }, () => {
            const newData = {
              title: values.title,
              is_simulation: true,
              simulation: {
                title: values.title,
                score: values.score,
                links: null,
                mode: "from_elearning_app"
              },
              lesson_id: lessonId,
              course_id: courseId
            }

            if (currentQuiz && currentQuiz.id) {
              // Assuming updateQuiz returns a promise
              this.updateQuiz(newData)
                .then(() => {
                  handleCloseQuizModal()
                  resolve()
                })
                .catch(reject)
            } else {
              console.log("newData: ", newData)
              api.quizes
                .quizCreate(newData)
                .then(res => {
                  this.handleInput(res.data)
                  this.setCurrentQuiz(res.data)

                  const uid = nanoid(8)
                  const data = {
                    content: res.data.id,
                    questions_count: 0,
                    isSimulation: true
                  }

                  if (
                    this.state.selectedOption !== 'Default' &&
                    this.state.sectionId !== 0
                  ) {
                    data.section_id = this.state.sectionId
                    data.sim_type = this.state.selectedOption
                  }

                  handleAddNewQuizElement({
                    uId: uid,
                    data: {
                      ...data,
                      x: 0,
                      y: 0,
                      height: 552,
                      width: 1023,
                    },
                  })

                  handleCloseQuizModal()
                  resolve()
                })
                .catch(reject)
            }
          })
        } else {
          reject(new Error('Validation failed'))
        }
      })
    })
  }

  handleScreenCapture = async () => {
    try {
      // Set processing state to true
      this.setState({ processingScreenCapture: true })

      const base_Url = config.baseURL.replace(/\/v1\/?$/, '')
      const ai_Url = config.questionAnswerAiUrl

      // This will now properly wait for the save operation to complete
      await this.handleSaveSimulationDeskstop()

      const { shlToken, refreshToken, currentQuiz } = this.state

      const {
        user: {
          info: { id }
        },
        lessonId,
        courseId,
        lessonBuilder: { currentPage },
        t
      } = this.props

      const title = this.state.simulationTitle
      const score = this.state.simulationScore

      console.log('refreshToken', refreshToken)

      // Check if currentQuiz and quiz_data exist before accessing custom_data
      const customDataParam = (currentQuiz?.quiz_data?.custom_data)
        ? `&project_data=${encodeURIComponent(JSON.stringify(currentQuiz.quiz_data.custom_data))}`
        : '';

      const deepLink = `sharelookapp://open?token=${shlToken}&refreshToken=${refreshToken}&base_Url=${base_Url}&ai_Url=${ai_Url}&userId=${id}&course_Id=${courseId}&lesson_Id=${lessonId}&page_Id=${currentPage}&title=${title}&score=${score}&is_simulation=${true}&simulation_id=${currentQuiz.id
        }&simulationMode=${'desktop'}&template_id=7${customDataParam}`
      console.log('deepLink', deepLink)

      // Show confirmation modal (this will now run after save is complete)
      this.showLaunchConfirmation(deepLink)
    } catch (error) {
      console.error('Error in handleScreenCapture:', error)
      // Handle error appropriately - maybe show error message to user
    } finally {
      // Reset processing state regardless of success or failure
      this.setState({ processingScreenCapture: false })
    }
  }

  // Show message when app launch fails
  showAppNotFound = () => {
    const { t } = this.props
    Modal.error({
      title: (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <FaExclamationTriangle
            style={{ marginRight: '8px', color: '#ff4d4f' }}
          />
          {t('v4:sharelook_not_found')}
        </div>
      ),
      content: (
        <div>
          <p style={{ marginBottom: '16px', lineHeight: '1.5' }}>
            {t('v4:sharelook_screen_capture_application_not_be_opened')}
          </p>
          <div style={{ textAlign: 'center', marginTop: '20px' }}>
            <Button
              type="primary"
              size="large"
              onClick={() => {
                window.open(
                  'https://mj-scorm-bucket.s3.us-east-1.amazonaws.com/windows-screen-capture-app/ELearningSetup.exe',
                  '_blank'
                )
                Modal.destroyAll()
              }}
            >
              <FaDownload style={{ marginRight: '6px' }} />
              {t('v4:download_sharelook')}
            </Button>
          </div>
        </div>
      ),
      okText: 'Close',
      width: 400,
      centered: true
    })
  }

  // Attempt to launch the app with proper user gesture
  attemptAppLaunch = deepLink => {
    console.log('Attempting to launch ShareLook with deepLink:', deepLink)

    // Show loading message
    const hide = message.loading('Opening ShareLook...', 2)

    // Track if app launched successfully
    let appLaunched = false

    const detectAppLaunch = () => {
      const onBlur = () => {
        appLaunched = true
        cleanup()
        hide()
        message.success('ShareLook opened successfully!')
      }

      const onVisibilityChange = () => {
        if (document.hidden) {
          appLaunched = true
          cleanup()
          hide()
          message.success('ShareLook opened successfully!')
        }
      }

      const cleanup = () => {
        window.removeEventListener('blur', onBlur)
        document.removeEventListener('visibilitychange', onVisibilityChange)
      }

      // Listen for app launch indicators
      window.addEventListener('blur', onBlur)
      document.addEventListener('visibilitychange', onVisibilityChange)

      // Check after delay if app didn't launch
      setTimeout(() => {
        cleanup()
        hide()
        if (!appLaunched) {
          this.showAppNotFound()
        }
      }, 3000)
    }

    try {
      // Method 1: Direct window location (most reliable with user gesture)
      detectAppLaunch()
      window.location.href = deepLink
    } catch (error) {
      console.error('Direct launch failed, trying fallback:', error)

      try {
        // Method 2: Create and click link (fallback)
        const link = document.createElement('a')
        link.href = deepLink
        link.target = '_self'
        link.style.display = 'none'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      } catch (fallbackError) {
        console.error('All launch methods failed:', fallbackError)
        hide()
        this.showAppNotFound()
      }
    }
  }

  // Show confirmation modal using Ant Design
  showLaunchConfirmation = deepLink => {
    const { t } = this.props
    const modal = Modal.confirm({
      title: (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <FaDesktop style={{ marginRight: '8px', color: '#1890ff' }} />
          {t('v4:launch_sharelook_application')}
        </div>
      ),
      content: (
        <div>
          <p style={{ marginBottom: '16px' }}>
            {t(
              'v4:this_will_open_the_sharelook_application_for_screen_capture'
            )}
          </p>
          <p style={{ color: '#666', fontSize: '14px', marginBottom: '0' }}>
            {t('v4:sharelook_dosenot_open')}
          </p>
        </div>
      ),
      okText: (
        <span>
          <FaDesktop style={{ marginRight: '6px' }} />
          {t('v4:open_sharelook')}
        </span>
      ),
      cancelText: t('v4:cancel'),
      okType: 'primary',
      width: 450,
      onOk: () => {
        this.attemptAppLaunch(deepLink)
      },
      onCancel: () => {
        console.log('User cancelled app launch')
      },
      footer: (_, { OkBtn, CancelBtn }) => (
        <div style={{ textAlign: 'center' }}>
          <CancelBtn />
          <OkBtn />
          <Button
            type="default"
            onClick={() => {
              window.open(
                'https://mj-scorm-bucket.s3.us-east-1.amazonaws.com/windows-screen-capture-app/ELearningSetup.exe',
                '_blank'
              )
              modal.destroy()
            }}
            style={{ marginLeft: '8px' }}
          >
            <FaDownload style={{ marginRight: '6px' }} />
            {t('v4:download_app')}
          </Button>
        </div>
      )
    })
  }

  renderSimulationModal = () => {
    const {
      currentQuiz,
      isFetching,
      isUploadingSimulation,
      selectedSimulation,
      selectedOption,
      sectionId
    } = this.state
    const {
      t,
      form: { getFieldDecorator },
      library: { uploadProgress }
    } = this.props

    const simulationTitle =
      currentQuiz && currentQuiz.simulation && currentQuiz.simulation.title
    const simulationScore =
      currentQuiz && currentQuiz.simulation && currentQuiz.simulation.score

    return (
      <>
        <Spin spinning={isFetching}>
          <Quiz.Main>
            <Form onSubmit={() => { }}>
              {/* <Form.Item label={t('v5:select_simulation_type')}>
                <Dropdown overlay={this.menu} trigger={['click']}>
                  <Button className="btn-type-select">{selectedOption}</Button>
                </Dropdown>
              </Form.Item> */}
              <Form.Item label={t('v3:name_simulation')} colon={false}>
                {getFieldDecorator('title', {
                  rules: [
                    {
                      required: true,
                      message: t('v4:title_simulation')
                    }
                  ],
                  initialValue: simulationTitle
                })(
                  <Input
                    type="text"
                    size="large"
                    onChange={e =>
                      this.setState({ simulationTitle: e.target.value })
                    }
                  />
                )}
              </Form.Item>

              <Form.Item name="simulation_score" label={t('v2:score')}>
                <Fragment>
                  <Tooltip
                    trigger={['focus']}
                    title={t('v3:score_between_one_hundred')}
                    placement="topLeft"
                    overlayClassName="numeric-input"
                  >
                    {getFieldDecorator('score', {
                      rules: [
                        {
                          required: true,
                          message: t('v3:required_simulation')
                        }
                      ],
                      initialValue: simulationScore || 5
                    })(
                      <InputNumber
                        size="large"
                        min={0}
                        max={100}
                        onChange={value =>
                          this.setState({ simulationScore: value })
                        }
                      />
                    )}
                  </Tooltip>
                </Fragment>
              </Form.Item>
              {selectedOption !== 'Default' && (
                <Form.Item name="section_id" label={t('v5:uload_section_file')}>
                  <Fragment>
                    {getFieldDecorator('section_id', {
                      rules: [
                        {
                          required: true,
                          message: t('v3:required_section_file')
                        }
                      ],
                      initialValue: sectionId
                    })(
                      <Upload
                        beforeUpload={file => {
                          const isJson = file.type === 'application/json'
                          if (!isJson) {
                            message.error('You can only upload JSON files!')
                            return false
                          }

                          const reader = new FileReader()
                          reader.onload = e => {
                            try {
                              const jsonData = JSON.parse(e.target.result)
                              console.log('Uploaded JSON Content:', jsonData)
                              this.setState({
                                sectionId: jsonData.section_id
                              })
                              // Handle the parsed JSON data here
                            } catch (error) {
                              message.error('Invalid JSON file!')
                              console.error('Error parsing JSON:', error)
                            }
                          }
                          reader.readAsText(file)

                          return false // Prevent auto-upload
                        }}
                        accept=".json"
                      >
                        <Button>
                          <Icon type="upload" /> {t('v4:upload_selection_file')}
                        </Button>
                      </Upload>
                    )}
                  </Fragment>
                </Form.Item>
              )}

              <Form.Item label={t('v5:simulation_mode')} colon={false}>
                <Select
                  value={this.state.simulationMode}
                  onChange={this.handleSimulationModeChange}
                  size="large"
                >
                  <Option value="From Web">{t('v4:from_web')}</Option>
                  <Option value="Create with Screen Capture">Create with Screen Capture</Option>
                  <Option value="Add from Organization library">{t('v4:from_org_library')}</Option>
                </Select>
              </Form.Item>

              {this.state.simulationMode === 'From Web' && (
                <Form.Item
                  label={t('v3:simulation')}
                  colon={false}
                  required={true}
                >
                  <Dropzone
                    accept={'*'}
                    onDrop={this.onDropSimulation}
                    style={{}}
                    disabled={isUploadingSimulation}
                  >
                    {({ getRootProps, getInputProps, isDragActive }) => (
                      <div
                        className={classNames(
                          'upload-dropzone',
                          'upload-dropzone_event',
                          {
                            'upload-dropzone_active': isDragActive
                          }
                        )}
                      >
                        <div className="upload-dropzone__button">
                          {isUploadingSimulation && uploadProgress.length ? (
                            <Button
                              className="rounded"
                              size="large"
                              icon="loading"
                            >
                              {uploadProgress[0].percent + '%'}
                            </Button>
                          ) : (
                            <div className="wrap_upload_buttons">
                              <Button
                                className="rounded"
                                size="large"
                                icon="picture"
                              >
                                {t('v3:upload_simulation')}
                              </Button>
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                  </Dropzone>
                </Form.Item>
              )}

              {this.state.simulationMode === 'Create with Screen Capture' && (
                <Form.Item>
                  <div style={{ textAlign: 'center', margin: '24px 0 16px 0' }}>
                    <Tooltip
                      title="This feature available for windows user only"
                      placement="top"
                    >
                      <Button
                        type="default"
                        size="large"
                        icon={
                          this.state.processingScreenCapture
                            ? 'loading'
                            : 'camera'
                        }
                        onClick={this.handleScreenCapture}
                        loading={this.state.processingScreenCapture}
                        disabled={this.state.processingScreenCapture}
                        style={{
                          backgroundColor: '#f0f2f5',
                          borderColor: '#d9d9d9',
                          color: '#595959'
                        }}
                      >
                        {this.state.processingScreenCapture
                          ? t('v4:pleae_wait_processing')
                          : t('v4:create_simulation_from_screen_capture')}
                      </Button>
                    </Tooltip>
                  </div>
                </Form.Item>
              )}

              {/* Show selected simulations when org library mode is active */}
              {this.state.simulationMode === 'Add from Organization library' &&
                this.state.selectedSimulation &&
                this.state.selectedSimulation.length > 0 && (
                  <List
                    header={<h2>{t('v3:selected_simulation_files')} </h2>}
                    footer={false}
                    style={{ marginBottom: '3rem' }}
                    size="small"
                    bordered
                    dataSource={this.state.selectedSimulation}
                    renderItem={item => (
                      <List.Item>
                        <Row
                          style={{ width: '100%' }}
                          type="flex"
                          justify="space-between"
                          align="middle"
                        >
                          <div>
                            <strong>{item.name}</strong>
                            <br />
                            <small style={{ color: '#8c8c8c' }}>
                              {item.description} | {item.date}
                            </small>
                          </div>
                          <Icon
                            type="close"
                            style={{ cursor: 'pointer', color: '#ff4d4f' }}
                            onClick={() => this.deleteSimulationFile(item.id)}
                          />
                        </Row>
                      </List.Item>
                    )}
                  />
                )}
            </Form>
          </Quiz.Main>
        </Spin>
        {/* Update the Modal section */}
        <Modal
          title="Select Simulation"
          visible={this.state.showSimulationModal}
          onCancel={this.handleModalClose}
          footer={null}
          width={900}
          bodyStyle={{ padding: '24px' }}
        >
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',

            }}
          >
            <Spin spinning={this.state.simulationListLoading} />
          </div>
          {this.state.simulationList && this.state.simulationList.length > 0 ? (
            <List
              grid={{
                gutter: 16,
                xs: 1,
                sm: 2,
                md: 2,
                lg: 3,
                xl: 3,
                xxl: 3,
              }}
              pagination={{
                pageSize: 9,
                showSizeChanger: false,
                total: this.state.totalSimulations,
                showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} simulations`
              }}
              dataSource={this.state.simulationList}
              renderItem={item => (
                <List.Item>
                  <div
                    onClick={() => this.handleSimulationSelect(item)}
                    style={{
                      border: '1px solid #d9d9d9',
                      borderRadius: '4px',
                      padding: '16px',
                      cursor: 'pointer',
                      textAlign: 'center',
                      transition: 'all 0.3s',
                      height: '100%',
                      minHeight: '200px',
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'space-between'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.borderColor = '#1890ff'
                      e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.15)'
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.borderColor = '#d9d9d9'
                      e.currentTarget.style.boxShadow = 'none'
                    }}
                  >
                    <div>
                      <Icon
                        type={item.icon}
                        style={{ fontSize: '48px', color: '#1890ff', marginBottom: '12px' }}
                      />
                      <h3 style={{
                        fontSize: '16px',
                        fontWeight: '500',
                        marginBottom: '8px',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap'
                      }}>
                        {item.name}
                      </h3>
                      <p style={{
                        fontSize: '12px',
                        color: '#595959',
                        marginBottom: '8px',
                        height: '36px',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        display: '-webkit-box',
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: 'vertical'
                      }}>
                        {item.description}
                      </p>
                    </div>
                    <p style={{
                      fontSize: '12px',
                      color: '#8c8c8c',
                      marginBottom: 0
                    }}>
                      <Icon type="calendar" /> {item.date}
                    </p>
                  </div>
                </List.Item>
              )}
            />
          ) : (
            !this.state.simulationListLoading && (
              <div style={{ textAlign: 'center', padding: '40px' }}>
                <Icon type="inbox" style={{ fontSize: '48px', color: '#d9d9d9' }} />
                <p style={{ marginTop: '16px', color: '#8c8c8c' }}>No simulations found</p>
              </div>
            )
          )}
        </Modal >
      </>
    )
  }

  handleSaveSimulation = () => {
    const {
      form: { validateFields },
      handleCloseQuizModal,
      handleAddNewQuizElement,
      lessonId,
      courseId,
      t
    } = this.props

    const {
      currentQuiz,
      selectedSimulation,
      sectionId,
      selectedOption
    } = this.state

    console.log("selectedOption", selectedOption)

    validateFields((err, values) => {
      console.log(err, values)
      if (!err) {
        if (selectedSimulation.length === 0) {
          message.error(`${t('v4:select_upload_simulation')}`)
          return
        }

        if (selectedOption !== 'Default' && sectionId === 0) {
          console.log('selectedOption', selectedOption, 'sectionId', sectionId)
          message.error(`${t('v4:select_upload_section_id')}`)
          return
        }

        console.log("selectedSimulation handleSaveSimulation", selectedSimulation)

        this.setState({ savingSimulation: true }, () => {
          const { currentQuiz, simulationMode } = this.state

          let simulationData;

          if (simulationMode === "From Web") {
            // From Web: use the custom structure
            simulationData = {
              title: values.title,
              score: values.score,
              links: selectedSimulation?.[0]?.fullData?.simulation?.links || [],
              sim_data: selectedSimulation?.[0]?.fullData?.simulation?.sim_data || {},
              mode: "from_web"
            };
          } else {
            // Copy links and sim_data from org library
            simulationData = {
              title: values.title,
              score: values.score,
              links: selectedSimulation?.[0]?.fullData?.simulation?.links || [],
              sim_data: selectedSimulation?.[0]?.fullData?.simulation?.sim_data || {},
              mode: "from_org_library"
            };
          }

          const newData = {
            title: values.title,
            is_simulation: true,
            simulation: simulationData,
            lesson_id: lessonId,
            course_id: courseId
          };

          console.log("before update newData", newData)

          if (currentQuiz && currentQuiz.id) {
            // Copy data but REMOVE mode so it doesn't overwrite existing DB value
            const updateData = {
              ...newData,
              simulation: {
                ...newData.simulation
              }
            };

            delete updateData.simulation.mode; // do not update mode

            this.updateQuiz(updateData);
            // Reset selectedSimulation after update
            this.setState({ selectedSimulation: [] });

          } else {
            // Create: mode should be included
            api.quizes.quizCreate(newData).then(res => {
              this.handleInput(res.data)
              this.setCurrentQuiz(res.data)

              const uid = nanoid(8)

              const data = {
                content: res.data.id,
                questions_count: 0,
                isSimulation: true
              }

              if (
                this.state.selectedOption !== 'Default' &&
                this.state.sectionId !== 0
              ) {
                data.section_id = this.state.sectionId
                data.sim_type = this.state.selectedOption
              }

              handleAddNewQuizElement({
                uId: uid,
                data: data
              })

              // Reset selectedSimulation after successful creation
              this.setState({ selectedSimulation: [] });
            }).catch(err => {
              console.error("Error creating quiz:", err);
              // Optionally reset on error too
              this.setState({ selectedSimulation: [] });
            })
          }
          handleCloseQuizModal()
        })
      }
    })
  }

  handleMenuClick = e => {
    this.setState({ selectedOption: e.item.props.children, sectionId: 0 })
    console.log('Selected key:', e.key)
  }

  handleMenuClick = e => {
    const selectedOption = e.item.props.children

    this.setState(
      prevState => ({
        selectedOption,
        sectionId: selectedOption === 'Default' ? 0 : prevState.sectionId
      }),
      () => {
        console.log('Selected Option:', this.state.selectedOption)
        console.log('Section ID:', this.state.sectionId)
      }
    )
  }

  menu = () => {
    return (
      <Menu onClick={this.handleMenuClick}>
        <Menu.Item key="default">Default</Menu.Item>
        <Menu.Item key="nyit">NYIT</Menu.Item>
        <Menu.Item key="dhl">DHL</Menu.Item>
      </Menu>
    )
  }

  render() {
    const {
      handleCloseQuizModal,
      pageBuilder: { contentId },
      t,
      handleAddNewQuizElement,
      visible,
      lessonId,
      courseId,
      lessonBuilder: { currentPage, pages }
    } = this.props
    const {
      formCreateVisible,
      manageVisible,
      questionsVisible,
      editQuestion,
      enableQuizGame,
      showMediaLibrary,
      selectedImage,
      coverLink,
      isAddSimulation,
      savingSimulation,
      isUploadingSimulation
    } = this.state

    let questions = []
    if (this.state.currentQuiz) {
      questions = this.state.currentQuiz.questions
    }
    const pageId = pages[currentPage - 1].id

    const showAddQuestion = questionsVisible && !editQuestion

    const canAddGame =
      questions &&
      questions.length > 0 &&
      questions.every(
        item => item.type === 'single' || item.type === 'multiple'
      )

    const showGameSelection =
      formCreateVisible || !canAddGame || isAddSimulation
        ? false
        : enableQuizGame && !questionsVisible && !editQuestion


    return (
      <Modal
        title={isAddSimulation ? t('v3:add_simulation') : ''}
        visible={visible}
        closable={isAddSimulation}
        onCancel={handleCloseQuizModal}
        width="fit-content"
        className="quiz-create"
        centered
        footer={
          <>
            {isAddSimulation &&
              this.state.simulationMode !== 'Create with Screen Capture' &&
              (
                <Button
                  shape="round"
                  className="shl-primary-btn"
                  loading={savingSimulation || isUploadingSimulation}
                  style={{ marginBottom: '5px', marginRight: '5px' }}
                  onClick={() => this.handleSaveSimulation()}
                >
                  {t('buttons:save')}
                </Button>
              )}
            {manageVisible ? (
              <Button
                shape="round"
                className="shl-secondary-btn"
                style={{ marginBottom: '5px' }}
                onClick={() => handleCloseQuizModal()}
              >
                {t('buttons:close')}
              </Button>
            ) : (
              ''
            )}
          </>
        }
      >
        <Quiz>
          {formCreateVisible && !isAddSimulation && (
            <Quiz.Main>
              <Quiz.Title>
                {_.isEmpty(contentId)
                  ? t('labels:quiz_create')
                  : t('labels:quiz_update')}
                <span
                  className="quiz-close-btn"
                  onClick={() => handleCloseQuizModal()}
                >
                  <CloseOutlined />
                </span>
              </Quiz.Title>

              <QuizCreation
                isFetching={this.state.isFetching}
                data={this.state.currentQuiz}
                handleInput={this.handleInput}
                setCurrentQuiz={this.setCurrentQuiz}
                handleCloseQuizModal={handleCloseQuizModal}
                onCancel={() => {
                  this.setVisible('formCreateVisible', false)
                  this.setVisible('manageVisible', true)
                }}
                ids={{
                  lessonId,
                  courseId,
                  pageId
                }}
              />
            </Quiz.Main>
          )}

          {isAddSimulation && this.renderSimulationModal()}

          {manageVisible && !showAddQuestion && !isAddSimulation && (
            <Quiz.Main>
              <Quiz.Header>
                <Quiz.Back>
                  <Icon type="left" />
                  <Quiz.Back.Label
                    onClick={() => {
                      this.setVisible('formCreateVisible', true)
                      this.setVisible('manageVisible', false)
                    }}
                  >
                    {t('buttons:back')}
                  </Quiz.Back.Label>
                </Quiz.Back>
              </Quiz.Header>

              <Quiz.Name>
                {t('labels:quiz_name')}:{' '}
                {this.state.currentQuiz
                  ? this.state.currentQuiz.title
                  : t('general:loading')}
              </Quiz.Name>

              <Quiz.Add
                onClick={this.onAddQuestion}
                disabled={!this.state.currentQuiz}
              >
                <Icon type="plus" />
                {t('buttons:add_question')}
              </Quiz.Add>

              {!_.isEmpty(questions) ? (
                <Fragment>
                  <hr
                    style={{ border: '1px solid #e6e4e4', margin: '2rem 0' }}
                  />

                  <Quiz.Info>
                    {t('v2:total')} {questions.length} {t('v3:items')}{' '}
                  </Quiz.Info>

                  <Quiz.List>
                    {questions.map((question, i) => (
                      <Quiz.Item
                        key={i}
                        active={editQuestion && editQuestion.id === i}
                      >
                        <Quiz.Item.Number>{i + 1}.</Quiz.Item.Number>{' '}
                        <Quiz.Item.Information>
                          <Quiz.Item.Name>{question.title}</Quiz.Item.Name>

                          <Quiz.Item.Events>
                            <Tooltip title={t('labels:edit')}>
                              <Quiz.Item.Event
                                size="small"
                                onClick={() => this.onEditQuestion(i)}
                                active={editQuestion && editQuestion.id === i}
                              >
                                <Icon
                                  type="edit"
                                  style={{ color: '#246CF6' }}
                                />
                              </Quiz.Item.Event>
                            </Tooltip>

                            <Popconfirm
                              title={t('warnings:delete')}
                              okText={t('general:yes')}
                              cancelText={t('general:no')}
                              icon={false}
                              onConfirm={() => this.onRemoveQuestion(i)}
                            >
                              <Tooltip title={t('v4:delete')}>
                                <Quiz.Item.Event size="small">
                                  <Icon
                                    type="close"
                                    style={{ color: '#FF0000' }}
                                  />
                                </Quiz.Item.Event>
                              </Tooltip>
                            </Popconfirm>
                          </Quiz.Item.Events>
                        </Quiz.Item.Information>
                      </Quiz.Item>
                    ))}
                  </Quiz.List>

                  <hr
                    style={{ border: '1px solid #e6e4e4', margin: '2rem 0' }}
                  />

                  {canAddGame ? (
                    <Checkbox
                      onChange={e => this.toggleQuizInGames(e.target.checked)}
                      defaultChecked={enableQuizGame}
                    >
                      {t('v3:simulation_quiz_games')}
                    </Checkbox>
                  ) : (
                    questions &&
                    questions.length > 0 && (
                      <Alert
                        type={t('v3:alert_info')}
                        description={t('v3:simulation_alert_des')}
                      />
                    )
                  )}
                </Fragment>
              ) : (
                <Quiz.Empty>{t('questions_empty')}</Quiz.Empty>
              )}
            </Quiz.Main>
          )}

          {questionsVisible && !formCreateVisible && !isAddSimulation && (
            <Quiz.Main style={{ marginLeft: editQuestion ? '3rem' : null }}>
              <Quiz.Header>
                <Quiz.Back
                  onClick={() => {
                    this.setVisible('questionsVisible', false)
                    if (editQuestion) {
                      this.setState({ editQuestion: null })
                    }
                  }}
                  style={{
                    justifyContent: editQuestion ? 'flex-end' : 'flex-start'
                  }}
                >
                  <Icon type={editQuestion ? 'close' : 'left'} />
                  <Quiz.Back.Label>
                    {editQuestion
                      ? t('buttons:close')
                      : t('labels:back_to_question')}
                  </Quiz.Back.Label>
                </Quiz.Back>
              </Quiz.Header>

              <QuizQuestions
                currentQuiz={this.state.currentQuiz}
                updateCurrentQuizQuestions={this.updateCurrentQuizQuestions}
                data={editQuestion}
                handleAddNewQuizElement={handleAddNewQuizElement}
                onCancel={() => {
                  this.setVisible('questionsVisible', false)
                  if (editQuestion) {
                    this.setState({ editQuestion: null })
                  }
                }}
              />
            </Quiz.Main>
          )}
          {showGameSelection && (
            <Quiz.Main style={{ marginLeft: '3rem' }}>
              <Quiz.Title>{t('v3:games')}</Quiz.Title>

              <div
                style={{
                  position: 'relative'
                }}
              >
                <div
                  className={classNames(
                    'upload-dropzone',
                    'upload-dropzone_event'
                  )}
                  style={{
                    backgroundImage: 'url(' + coverLink + ')'
                  }}
                >
                  <div className="wrap_upload_buttons">
                    <Button
                      className="rounded"
                      size="large"
                      icon="filepdfoutlined"
                      onClick={e => {
                        e.stopPropagation()
                        this.setVisible('showMediaLibrary', true)
                      }}
                    >
                      {t('buttons:select_media_library')}
                    </Button>
                  </div>
                </div>
              </div>
            </Quiz.Main>
          )}

          {showMediaLibrary && (
            <Modal
              visible={showMediaLibrary}
              onCancel={() => this.setVisible('showMediaLibrary', false)}
              centered
              footer={null}
              width={'80%'}
            >
              <div className="wrap_modal_tabs">
                <PopupMedia
                  isGame
                  isPageBuilder
                  handleInsertData={this.handleSelectImage}
                />
              </div>
            </Modal>
          )}
        </Quiz>
      </Modal>
    )
  }
}

export default Form.create()(withTranslation('quiz')(EQuiz))
